import React from 'react';
import { Trans } from 'react-i18next';

import { TextSmall } from '@/components/Typography/Typography';
import { VipIcon } from '@/components/ui/Icons';

const VipEarnInfo: React.FC = () => {
  return (
    <div className="w-full rounded-[80px] py-1 bg-main-bg flex gap-2 justify-center items-center">
      <VipIcon className="w-6 h-6 shrink-0" />
      <TextSmall weight="medium">
        <Trans
          i18nKey={'Get <1>+5%</1> in USD when VIP is active'}
          components={{ 1: <span className="text-[#FFD600] font-[700]" /> }}
        />
      </TextSmall>
      <VipIcon className="w-6 h-6 shrink-0" />
    </div>
  );
};

export default VipEarnInfo;
